/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import {
  Space,
  Input,
  Tooltip,
  Popconfirm,
  message,
  Table,
  Button,
  Row,
  Form,
} from "antd";
import { useParams } from "react-router-dom";

import { capitalize, serialNum } from "../../../utils";

import { QuestionCircleOutlined } from "@ant-design/icons";
import { ReactComponent as Edit_icon } from "../../../assests/images/eyeIcon.svg";
import { ReactComponent as Mail_sent } from "../../../assests/images/SVG/mail-sent-icon.svg";
import { ReactComponent as Pfd_icon } from "../../../assests/images/SVG/pdf-icon.svg";
import { ReactComponent as Pfd_red_icon } from "../../../assests/images/SVG/pdf-red-icon.svg";

import { ReactComponent as Mail_in } from "../../../assests/images/SVG/mail-in-icon.svg";
import { ReactComponent as Disable_Edit_icon } from "../../../assests/images/SVG/disableEdit.svg";

import search_icon from "../../../assests/images/search-icon.svg";
import check_mark from "../../../assests/images/SVG/check.svg";
import Smcs_Loader from "../../../assests/images/loader-new.gif";
import Heading from "../../../components/Heading";
import urls from "../../../api/urls";
import API from "../../../api";
import EllipsisWithTooltip from "../../../components/EllipsisWithToolTip";
import { ReactComponent as EyeIcon } from "../../../assests/images/eyeIcon.svg";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../../components/customNavigationHook";

const { GET_LEAD_CP_QUOTE_TABLE, GET_RATE_CARD_QUOTATION } = urls;

const CPQuotationList = () => {
  const { state } = useLocation();
  const debounceTimeout = useRef(null);
  const param = useParams();
  const navigate = useCustomNavigate();
  const [cpName, setCpName] = useState(null);
  let [tableData, setTableData] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPageSize, setTotalPageSize] = useState("");
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    getQuoteTable("?pageNum=0&pageSize=10");
  }, []);

  const statusList = [
    {
      value: "APPROVED",
      text: "Approved",
    },
    {
      value: "PENDING",
      text: "Pending",
    },
    {
      value: "REJECTED",
      text: "Rejected",
    },
  ];

  const getQuoteTable = async (page) => {
    setLoading(true);
    let response = await API.Api(
      GET_RATE_CARD_QUOTATION + "all/" + param?.id + page
    ).getWithUserNPremiseHeader();
    if (response?.status) {
      setLoading(false);
      let temp = response?.response?.data?.items;
      setTableData(temp);
      setTotalPageSize(response?.response?.data?.total);
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message || "Network Error");
    }
  };

  const handlePageChange = (pagination, filters) => {
    if (filters?.approvalStatus) {
      getQuoteTable(
        `?pageNum=${pagination.current - 1}&pageSize=${
          pagination.pageSize
        }&approvalStatus=${filters?.approvalStatus[0]}`
      );
    } else {
      getQuoteTable(
        `?pageNum=${pagination.current - 1}&pageSize=${pagination.pageSize}`
      );
    }
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);
    setCurrentPage(pagination.current);
  };

  const onSearch = (e) => {
    const currValue = e.target.value;
    setPageNum(0);
    setPageSize(pageSize);
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(async () => {
      //getClientApprovalList(0, 20, currValue);
      getQuoteTable(
        `?pageNum=${pageNum}&pageSize=${pageSize}&searchTerm=${currValue}`
      );
    }, 500);
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const columns = [
    // {
    //   title: "Quote Id",
    //   dataIndex: "rateCardId",
    //   key: "rateCardId",
    //   align: "center",
    //   width: 50,
    //   render: (text, record, idx) => {
    //     let check =
    //       record?.status?.toLowerCase() !== "approved" &&
    //       record?.status?.toLowerCase() !== "rejected";
    //     return check ? (
    //       <a onClick={() => navigate("/cp-quotation-edit/" + param?.id)}>
    //         {text}
    //       </a>
    //     ) : (
    //       text
    //     );
    //   },
    // },
    {
      title: "Sl No",
      dataIndex: "key",
      key: "key",

      render: (a, b, idx) => serialNum(pageSize, pageNum, idx),
    },
    {
      title: "Quotation",
      dataIndex: "name",
      key: "name",

      width: 200,
      render: (text, val) => {
        return (
          <>
            <div>{text || "N/A"}</div>
          </>
        );
      },
    },
    {
      title: "Rate Type",
      dataIndex: "type",
      key: "type",

      width: 80,
      render: (text, val) => {
        return (
          <>
            <div>{text || "N/A"}</div>
          </>
        );
      },
    },
    {
      title: "Commited Business",
      dataIndex: "commitedBusiness",
      key: "commitedBusiness",
      align: "center",
      width: 160,
    },
    {
      title: "Date Range",
      dataIndex: "fromDate",
      key: "fromDate",

      render: (text, record) => (
        <span>
          {record?.fromDate} <strong>-</strong> {record.toDate}
        </span>
      ),
    },
    // {
    //   title: "To Date",
    //   dataIndex: "toDate",
    //   key: "toDate",
    //
    // },
    {
      title: "Reject Reason",
      dataIndex: "rejectionReason",
      key: "rejectionReason",

      width: 250,
      render: (text) => (text ? <EllipsisWithTooltip text={text} /> : "N/A"),
    },
    {
      title: "Status",
      dataIndex: "approvalStatus",
      key: "approvalStatus",

      filters: statusList,
      width: 100,
      filterMultiple: false,

      render: (text) => {
        return (
          <div
            className={`lead-list-status ${"CPlead_" + text?.toLowerCase()}`}
          >
            {capitalize(text) || "--"}
          </div>
        );
      },
    },

    {
      title: "Actions",
      key: "action",
      align: "center",
      className: "actions-col",
      width: 150,

      render: (_, record) => {
        return (
          <Tooltip title={"View"} placement="bottom">
            <p
              className="pointer"
              style={{ marginBottom: 0 }}
              onClick={() =>
                // navigate(
                //   "/lead-cp-approval-confirmation/pending/" + param?.id,
                //   {
                //     state: {
                //       type: "cp-lead",
                //       rateCards: [
                //         {
                //           rateCardName: record?.name,
                //           rateCardType: record?.type,
                //           status: record?.approvalStatus,
                //         },
                //       ],
                //     },
                //   }
                // )
                navigate("/ratecards", {
                  state: {
                    rateCard: record?.name,

                    actionEdit: false,
                    customerId: param?.id,
                    //rateCardType: e?.rateCardType,
                  },
                })
              }
            >
              <Edit_icon />
            </p>
          </Tooltip>
        );
      },
    },
  ];

  // const id =
  //   {
  //     CLIENT: "2",
  //     COMPANY: "3",
  //   }[state] || "1";

  return (
    <>
      <div className="lead-gen-list-container mt-1 ml-2">
        {state?.tab ? (
          <Heading
            title="Quotation History"
            navigateTo={state?.navigateUrl}
            id={state?.tab}
          />
        ) : (
          <Heading title="Quotation History" />
        )}
      </div>
      <div className="master-main-container m-1">
        <div className="align-center space-between">
          <div className="p-1">
            <Input
              placeholder="Search by keyword"
              bordered
              onChange={onSearch}
              style={{ borderRadius: "5px", height: "40px", width: "400px" }}
              suffix={<img src={search_icon} />}
            />
          </div>
        </div>
        <Table
          className="table-head-sticky"
          loading={{
            indicator: (
              <img
                src={Smcs_Loader}
                style={{ height: "100px", width: "100px" }}
              />
            ),
            spinning: loading,
          }}
          columns={columns}
          // loading={loading}
          defaultCurrent={1}
          onChange={handlePageChange}
          // dataSource={tableData}
          dataSource={tableData}
          pagination={{
            // pageSize: pageSize,
            // total: inputSearchValue.length == 0 ? tableData.length : 10,
            current: currentPage,
            pageSize: pageSize,
            total: totalPageSize,
            itemRender: itemRender,
          }}
        />
        {/* <Table
          className="table-head-sticky"
          loading={{
            indicator: (
              <img
                src={Smcs_Loader}
                style={{ height: "100px", width: "100px" }}
              />
            ),
            spinning: loading,
          }}
          columns={columns}
          pagination={false}
          dataSource={tableData}

        /> */}
      </div>
    </>
  );
};

export default CPQuotationList;
